export const STREAM_CLIENT_SET = 'STREAM_CLIENT_SET'
export const STREAM_ERROR_SET = 'STREAM_ERROR_SET'
export const STREAM_MESSAGE = 'STREAM_MESSAGE'
export const STREAM_LAST_EVENT_SET = 'STREAM_LAST_EVENT_SET'